import * as React from 'react'
import { ConversationMessageText } from "../../../../../types";
import MessageParagraph from "../MessageParagraph";
import showdown from '../../../../../utilities/showdown';

interface IProps {
  message: ConversationMessageText
}

const Text = (props: IProps) => {
  const { message } = props

  return (
    <MessageParagraph
      dangerouslySetInnerHTML={{ __html: showdown.makeHtml(message.content) }}
    />
  )
}

export default Text